/**
 * Generating handover passwords.
 *
 * A sysadmin setting someone else's password invents "Summer2026" if left to
 * type one, and this account can spend GPU money. The app generates instead,
 * shows it once, and the server forces the recipient to replace it at first
 * sign-in, so it only ever has to survive being pasted into a message.
 */

/**
 * No O/0, I/l/1, or symbols. The password gets read aloud, retyped from a
 * screenshot, and pasted into chat clients that eat punctuation; the length
 * carries the strength instead.
 */
const ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789'

/** Comfortably past the server's 12-character floor. */
const LENGTH = 20

/**
 * A uniform index below `bound`.
 *
 * crypto, not Math.random: this is a credential. And rejection rather than a
 * plain modulo, because 2^32 is not a multiple of 57 — taking the remainder
 * would make the first few letters of the alphabet measurably likelier.
 */
function randomIndex(bound: number): number {
  const limit = Math.floor(0x1_0000_0000 / bound) * bound
  const buffer = new Uint32Array(1)
  for (;;) {
    crypto.getRandomValues(buffer)
    const value = buffer[0] ?? 0
    if (value < limit) return value % bound
  }
}

export function generatePassword(length = LENGTH): string {
  let out = ''
  for (let i = 0; i < length; i += 1) out += ALPHABET[randomIndex(ALPHABET.length)]
  return out
}
